import React from "react";

const AllDone = () => {
  return (
    <div className="flex flex-col items-center justify-center mx-auto mt-20">
      <img
        src="./illustrations/yellowtruck.png"
        alt="Yellow Truck"
        style={{ width: 300 }}
        className="object-contain"
      />
      <p className="-mt-8 text-lg font-semibold text-slate-700">All done</p>
      <p className="text-xs text-slate-500">No workflows to review for now</p>
    </div>
  );
};

export default AllDone;
